module.exports = __webpack_public_path__ + "img/avatar.20c74952.png";